var _ = require("underscore");
var SavePointData = require("./savePointData.js");

var AssetData = function (data) {
    this.id = data['id'];   //for closure compiler
    this.deleted = data['deleted'];
    this.name = data['name'];
    this.description = data['description'];
    this.summary = data['summary'];
    this.tags = data['tags'];
    this.type = data['type'];
    this.score = data['score'];
    this.private = data['private'];
    this.user_id = data['user_id'];
    this.user_name = data['user_name'];
    this.created_at = data['created_at'];
    this.sharejs_id = data['sharejs_id'];
    this.updated_at = data['updated_at'];
    this.save_points = data['save_points'];
    this.thumbnail = data['thumbnail'];
    this.permissions = data['permissions'];
    this.version = data['version'];
    this.usage_count = data['usage_count'];
    this.hub = data['hub'];
    this.hub_name = data['hub_name'];

    // is passing by reference here ok?  might need a (shallow) copy
    this.properties = data['properties'];
    this.forked_from = data['forked_from'];
    if(data['forked_from']) this.forked_from.wip_urn = data['forked_from']['wip_urn'];
    
    // for 3d models
    this.f3d = data['f3d'];
    this.stepStatus = data['stepStatus'];
    this.objStatus = data['objStatus'];
    this.hasXrefs = data['hasXrefs'];

    //_.extend(this, data);

    this.updated_at = new Date(this.updated_at);
    this.created_at = new Date(this.created_at);

    this.save_points = this.save_points || [];
    this.save_points = this.save_points.map(function(version) { return new SavePointData(version);});
};
module.exports = AssetData;

AssetData.prototype.getSavePoints = function() {
    return this.save_points;
};

AssetData.prototype.getVersions = function() {
    return this.save_points.filter(function(save_point) { return save_point.type == 'savedSnapshot'; });
};

AssetData.prototype.getSavePointForSpecificVersion = function(version) {
    var specificSavePoint = this.save_points.filter(function(save_point) {return save_point.version == version && save_point.type == "savedSnapshot"});
    return specificSavePoint[0];
};

AssetData.prototype.getLastVersion = function() {
    var versions = this.getVersions();
    var latestVersion = null;
    var latestVersionNum = 0;

    for(var i = 0; i < versions.length; i++){
        if(versions[i].version > latestVersionNum){
            latestVersionNum = versions[i].version;
            latestVersion = versions[i];
        }
    }

    return latestVersion;
};

AssetData.prototype.getNextVersionNumber = function() {
    var last_version = this.getLastVersion();
    if(last_version)
        return this.getLastVersion().version + 1;
    else
        return 1;
};


AssetData.prototype.hasAVersion = function() {
    return this.getVersions().length > 0;
};

AssetData.prototype.getImports = function() {
    return this.save_points.filter(function(save_point) { return save_point.type == 'import'; });
};

AssetData.prototype.getLastImport = function() {
    var imports = this.getImports();
    if(imports.length == 0)
        return null;
    else
        return imports[imports.length-1];
};

AssetData.prototype.hasUserWritePermissions = function() {
    return this.permissions.indexOf('edit resource') != -1;
};

AssetData.prototype.hasUserPublishPermissions = function() {
    return this.permissions.indexOf('publish resource') != -1;
};
